export default [
  {path: 'pdftoimage', name: 'pdftoimage', component: () => import('../pages/tools/PdfToImage.vue')},
  {path: 'yysb', name: 'yysb', component: () => import('../pages/tools/UseSpeechRecognition.vue')},
  {path: 'speak', name: 'yysb', component: () => import('../pages/tools/Speak.vue')},
]
